module.exports = __webpack_public_path__ + "img/sdk-entry-mobile-back.2cd4b983.png";